import React from 'react';

const DeleteAccount = () => {
  return (
    <div className="legal-page" style={{ maxWidth: 900, margin: '20px auto', padding: '16px' }}>
      <h1>Delete Account Request</h1>
      <p><strong>Effective date:</strong> March 19, 2026</p>
      <p>
        This page explains how users of DashBasket services can request deletion of their account and
        associated personal data.
      </p>

      <h2>Applies to</h2>
      <ul>
        <li>DashBasket (Customer App)</li>
        <li>Dash Resto (Restaurant App)</li>
        <li>Dash Driver (Driver App)</li>
      </ul>

      <h2>How to request account deletion</h2>
      <ol>
        <li>
          Send an email to <a href="mailto:sotairekwizera@gmail.com">sotairekwizera@gmail.com</a> with the
          subject line: <strong>Delete My DashBasket Account</strong>.
        </li>
        <li>In the email body, include the phone number or email used to register your account.</li>
        <li>Specify which app account you want deleted: DashBasket, Dash Resto, or Dash Driver.</li>
      </ol>

      <h2>What data is deleted</h2>
      <ul>
        <li>Profile/account information linked to the account.</li>
        <li>Stored addresses and app profile details.</li>
        <li>Associated app usage records that are not required for legal or security reasons.</li>
      </ul>

      <h2>What data may be retained</h2>
      <ul>
        <li>Order or transaction records required for legal, tax, anti-fraud, and audit obligations.</li>
        <li>Security logs needed to investigate abuse or policy violations.</li>
      </ul>

      <h2>Deletion timeline</h2>
      <p>
        We aim to process verified deletion requests within 30 days.
      </p>

      <h2>Contact</h2>
      <p>
        Email: <a href="mailto:sotairekwizera@gmail.com">sotairekwizera@gmail.com</a>
      </p>
    </div>
  );
};

export default DeleteAccount;
